import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccreditationFinancialService } from 'src/app/features/cabs/modules/accreditation-financial/services/accreditation-financial.service';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html'
})
export class PaymentConfirmationComponent implements OnInit {

  paymentToken: any
  constructor(private route: ActivatedRoute,
    private router: Router,
    private service: AccreditationFinancialService,
    public toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      let token = params.get('token');
      this.confirmPayment(token);
    });
  }

  confirmPayment(token: string) {
    let model = { paymentToken: token };
    this.service.ConfirmPayment(model).subscribe(
      response => {
        if (response.status != "succsess") {
          this.showError(response?.message);
        } 
        response?.payment_redirect_url ?
          this.router.navigate([response?.payment_redirect_url]) :
          this.router.navigate(['/'])
        console.log(response);
      },
      (error) => {
        if (error?.message) {
          this.showError(error?.message);
        }
        this.router.navigate(['/'])
      }
    )
  }

  showError(msg) {
    this.toastr.error(msg);
  }

  showSuccess(msg) {
    this.toastr.success(msg);
  }

}
